import React from "react";
import {
  SiPowerbi,
  SiMicrosoftsqlserver,
} from "react-icons/si";
import { MdOutlineSchema, MdDashboardCustomize } from "react-icons/md";
import { HiOutlineChartBar } from "react-icons/hi";
import { FaDatabase } from "react-icons/fa";
import { motion } from "framer-motion";
import Title from "../layouts/Title";
import Card from "./Card";

const Features = () => {
  return (
    <section
      id="services"
      className="
        w-full py-20
        border-b border-b-black
        relative
      "
    >
      {/* subtle background glow */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/20 to-transparent pointer-events-none" />

      <div className="relative z-10">
        <Title title="SERVICES" des="What I Do" />

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-20"
        >
          <Card
            title="Power BI Report Development"
            des="Design and develop interactive dashboards that convert complex data into clear business insights."
            icon={<SiPowerbi />}
          />

          <Card
            title="SQL & Data Modeling"
            des="Build optimized SQL queries, star schemas, and semantic models for accurate reporting."
            icon={<SiMicrosoftsqlserver />}
          />

          <Card
            title="DAX & Advanced Calculations"
            des="Create advanced DAX measures, KPIs, and time-intelligence calculations."
            icon={<MdOutlineSchema />}
          />

          <Card
            title="Microsoft Fabric & Data Engineering"
            des="Design scalable data pipelines and analytics solutions using modern data platforms."
            icon={<FaDatabase />}
          />

          <Card
            title="Data Analysis & Insights"
            des="Analyze datasets to uncover trends, patterns, and actionable business insights."
            icon={<HiOutlineChartBar />}
          />

          <Card
            title="Performance Optimization"
            des="Optimize Power BI models and reports for faster performance and better scalability."
            icon={<MdDashboardCustomize />}
          />
        </motion.div>
      </div>
    </section>
  );
};

export default Features;
